import React, { Component } from 'react';
import { connect } from 'react-redux';
import { shape, string, func } from 'prop-types';
import {
  patchSurveyCourseParticipantsUpdate, getSurveyInfo, getSurveyResults, getSurveySchedule
} from '../../api';
import {
  addErrorMessageAction, clearSurveyAction, setTaskFulfilled, setTaskPending
} from '../../actions';
import withRouter from '../WithRouter';

const WithStatistics = (WrappedComponent) => {
  class StatisticsWrapper extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    componentDidMount() {
      this.getSurveyData();
    }

    getSurveyData() {
      this.props.dispatchSetTaskPending();
      const { surveyId } = this.props.params;
      getSurveyResults(surveyId)
        .then((json) => {
          this.setState({ surveyStats: json });
        })
        .catch((err) => {
          if (err.status !== 404) {
            this.props.dispatchAddErrorMessage(err);
          }
        });

      patchSurveyCourseParticipantsUpdate(surveyId).then(() =>
        Promise.all([
          getSurveyInfo(surveyId),
          getSurveySchedule(surveyId)
        ])
          .then(([surveyInfo, surveySchedule]) => this.setState({ surveyInfo, surveySchedule }))
          .catch((err) => {
            this.props.dispatchAddErrorMessage(err);
          })
          .finally(this.props.dispatchSetTaskFulfilled));
    }

    render() {
      return (
        <WrappedComponent
          surveyStats={this.state.surveyStats}
          surveyInfo={this.state.surveyInfo}
          surveySchedule={this.state.surveySchedule}
          {...this.props}
        />
      );
    }
  }

  StatisticsWrapper.propTypes = {
    params: shape({
      surveyId: string
    }).isRequired,
    dispatchAddErrorMessage: func.isRequired,
    dispatchSetTaskPending: func.isRequired,
    dispatchSetTaskFulfilled: func.isRequired
  };

  const mapDispatchToProps = (dispatch) => ({
    dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err)),
    dispatchSetTaskPending: () => dispatch(setTaskPending()),
    dispatchSetTaskFulfilled: () => dispatch(setTaskFulfilled()),
    dispatchClearSurvey: () => dispatch(clearSurveyAction())
  });

  return withRouter(connect(null, mapDispatchToProps)(StatisticsWrapper));
};

export default WithStatistics;
